import React from 'react'
import { Paragraph, colors, BillboardText, useContainerWidth, H2 } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Link } from '@fs/zion-router'
import familySearchBuilding from './images/family-search-building.jpg'

const row = css`
  display: flex;
  flex-direction: wrap;
  align-items: center;
`
const imageContainer = css`
  position: relative;
`
const imageContainerColumn = css`
  position: relative;
  width: 50%;
`
const imgSizingSmall = css`
  display: block;
  width: 100%;
`
const imgSizingLarge = css`
  display: block;
  width: 100%;
  height: 432px;
  object-fit: cover;
`
const imgTextColor = css`
  color: ${colors.white90};
  background: ${colors.transparent.gray100};
  padding: 14px 20px;
`
const imgText = css`
  position: absolute;
  bottom: -1px;
  padding: 14px 0px;
`
const textContainerSmall = css`
  padding: 48px 24px;
  max-width: 560px;
  margin: 0 auto;
`
const textContainerLarge = css`
  padding: 72px 24px;
  max-width: 560px;
  margin: 0 auto;
`
const textContainerColumn = css`
  width: 50%;
  padding: 0 80px;
  max-width: 640px;
`
const overlineSmall = css`
  background-color: ${colors.yellow40};
  width: 60px;
  height: 4px;
  margin-bottom: 24px;
`
const overlineLarge = css`
  background-color: ${colors.yellow40};
  width: 84px;
  height: 4px;
  margin-bottom: 36px;
`
const bodyTextSpacer = css`
  margin-top: 12px;
  margin-bottom: 24px;
`
const textEnhancer = css`
  position: absolute;
  bottom: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 60px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 165.08%);
`

export default function AboutPageFamilySearchPriceless({ nonReligiousMode }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <div css={atWidth({ xxl: row })}>
      <div css={atWidth({ default: imageContainer, xxl: imageContainerColumn })}>
        <img css={atWidth({ default: imgSizingSmall, md: imgSizingLarge })} src={familySearchBuilding} alt="" />
        <div css={textEnhancer} />
        <span css={imgText}>
          <Paragraph size="sm">
            <span css={imgTextColor}>{t('about.familysearch.office', 'FamilySearch Office, Lehi, Utah, USA')}</span>
          </Paragraph>
        </span>
      </div>
      <div css={atWidth({ default: textContainerSmall, xs: textContainerLarge, xxl: textContainerColumn })}>
        <div css={atWidth({ default: overlineSmall, xs: overlineLarge })} />
        <BillboardText primaryColor={colors.yellow40}>
          <H2 size={atWidth({ default: 'H5', xs: 'H4' })}>{t('about.free-to-all.heading', 'Free to All')}</H2>
        </BillboardText>
        <div css={bodyTextSpacer}>
          <Paragraph size="md">
            {t(
              'about.free-to-all.body',
              'The Church of Jesus Christ of Latter-day Saints provides FamilySearch free of charge to everyone, regardless of tradition, culture, or religious affiliation. FamilySearch resources help millions of people around the world discover their heritage and connect with family members.'
            )}
          </Paragraph>
        </div>
        {!nonReligiousMode && (
          <Paragraph size="sm">
            <Link to="/home/sponsorship" linkName="about:churchs-connection">
              {t('about.churchs-connection.link', 'More about the Church’s connection')}
            </Link>
          </Paragraph>
        )}
        <Paragraph size="sm">
          <Link to={`/${i18n.language}/legal/privacy`} linkName="about:protect-privacy" external>
            {t('sponsorship.how-we-protect-your-privacy.link', 'How we protect your privacy')}
          </Link>
        </Paragraph>
      </div>
    </div>
  )
}
